export default "__VITE_ASSET__CXkyzA97__"